import { Game, Maybe } from '@lib/graphql-types';

export const formatOdds = (odds: number | string): string => {
  if (odds === null || odds === undefined) {
    return '';
  }

  // Ensure odds is a number
  const parsedOdds = typeof odds === 'string' ? parseFloat(odds) : odds;

  if (isNaN(parsedOdds)) {
    return odds.toString();
  }

  // Format odds based on value
  return parsedOdds > 0 ? `+${parsedOdds}` : `${parsedOdds}`;
};

export const toMoney = (value: number | string): string => {
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(typeof value === 'string' ? parseFloat(value) : value);
};

export const calculatePayout = (odds: number | string, wager: number | string): number => {
  if (odds === null || odds === undefined || wager === null || wager === undefined) {
    return 0;
  }

  // Ensure odds and wager are numbers
  const parsedOdds = typeof odds === 'string' ? parseFloat(odds) : odds;
  const parsedWager = typeof wager === 'string' ? parseFloat(wager) : wager;
  if (isNaN(parsedOdds) || isNaN(parsedWager)) {
    return 0;
  }
  if (parsedOdds < 0) {
    const payout = parsedWager + (parsedWager / Math.abs(parsedOdds)) * 100;
    return parseFloat(payout.toFixed(2));
  }
  // Calculate payout
  const payout = (parsedOdds / 100) * parsedWager + parsedWager;
  return parseFloat(payout.toFixed(2));
};

export const formatWager = (wager: number | string): string => {
  if (wager === null || wager === undefined) {
    return '';
  }

  // Ensure wager is a number
  const parsedWager = typeof wager === 'string' ? parseFloat(wager) : wager;

  if (isNaN(parsedWager)) {
    return toMoney(wager);
  }

  // Format wager with a dollar sign
  return toMoney(parsedWager.toFixed(2));
};

export const formaPayout = (value: number | string): string => {
  return toMoney(value);
};

// skip testing until is implemented
// istanbul ignore next
export const isGameAvailableForBetting = (_?: Maybe<Pick<Game, 'status'>>): boolean => {
  // try {
  //   const status = game.status.toLowerCase();
  //   // Check if the game is in a state that allows betting
  //   return status !== 'final' && status !== 'postponed' && status !== 'cancelled';
  // } catch (error) {
  //   console.error('Error checking if game can be bet:', error);
  //   return false;
  // }
  return true;
};
